import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Row, Form } from "@themesberg/react-bootstrap";
import { paymentMethodsWithdrawal, statusType, transactionType, transactionTableHeaders, depositCryptoCheck, withdrawlCryptoCheck } from "../constants";
import useTransactionBList from "../hooks/useTransactionBList";
import DateRangePicker from "../../../../components/DateRangePicker";
import { getDateDaysAgo } from "../../../../utils/dateFormatter";
import TransactionsList from "../../../../components/TransactionsList";
import Trigger from "../../../../components/OverlayTrigger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "../../../../components/Toast";
import styled from "styled-components";
import { CustomCol, StyledSelect } from "../style";
import NotificationIconContainer from "../../../../components/NotificationIcon/NotificationIconContainer";
import useTableCustom from "../../../../components/CusotmFilter"
import DateFilterDropdown from "../../../../components/CustomDateFilterOptions";


export default function Withdrawals() {
  const {
    setLimit,
    setPage,
    totalPages,
    limit,
    page,
    state,
    setState,
    transactions,
    loading,
    status,
    setStatus,
    agentId,
    setSearchString,
    setPaymentMethod,
    paymentMethod,
    searchString,
    openStatusModal,
    closeStatusModal,
    handleStatusChange,
    handleAgentIdChange,
    updateTransactionStatus,
    updatingStatus,
    newStatus,
    showStatusModal,
    selectedTransaction,
    driversList,
    handleDownload,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    openCryptoStatusModal,
    showCryptoStatusModal,
    setShowCryptoStatusModal,
    updateCryptoTransactionStatus,
    loadingCrypto,
    setSelectedTransaction,
    selectedCrypto


  } = useTransactionBList({
    isUserDetail: false,
    transactionType: "withdrawal",
  });


  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState(null);
  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,

  } = useTableCustom(transactions?.rows,
    transactionTableHeaders?.withdrawal,
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "withdrawl");

  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight  // padding/margin
      const availableHeight = window.innerHeight - totalHeight - 125;
      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
      }

      setTableMaxHeight(`${availableHeight}px`);

    };

    updateMaxHeight(); // initial
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [transactions, visibleColumns]);

  return (
    <div >
      <div className="section-header-wrap mt-0 mx-n3" ref={headerRef}>
        <Row className="align-items-center">
          <Col lg={6} xs={6}>
            <h2 className="title-text">Withdrawal Requests</h2>
          </Col>

          <Col lg={6} xs={6} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>
      <div className="FormsBg" ref={filterRef}>
        <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>
          <CustomCol xs={12} md={4} lg={4}>
            <Form.Control
              type="search"
              value={searchString}
              placeholder="Search by name or email"
              onChange={(e) => setSearchString(e.target.value)}
              className="mb-2 mb-md-0"
            />
          </CustomCol>

          <CustomCol xs={12} md={6} lg={3}>
            <StyledSelect
              size="sm"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="mb-2 mb-md-0"
            >
              <option value="">Filter by payment method</option>
              {paymentMethodsWithdrawal.slice(0, 5).map(({ label, value }) => (
                <option key={label} value={value}>
                  {label}
                </option>
              ))}
            </StyledSelect>
          </CustomCol>

          <CustomCol xs={12} md={3} lg={2}>
            <StyledSelect
              size="sm"
              value={status}
              onChange={(e) =>
                setStatus(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ""))
              }
              className="mb-2 mb-md-0"
            >
              {statusType.map(({ label, value }) => {
                return (
                  <option key={label} value={value}>
                    {label}
                  </option>
                );
              })}
            </StyledSelect>
          </CustomCol>


          <CustomCol xs={12} md={3} lg={2}>
            <DateFilterDropdown state={state}
              setState={setState} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
          </CustomCol>

          {selectedFilter === "custom" && <CustomCol xs={12} md={3} lg={2}>
            <DateRangePicker
              state={state}
              setState={setState}
              size="sm"
              className="mb-2 mb-md-0"
            />
          </CustomCol>}



          <Row className="g-2 align-items-center mt-2 mt-md-0">
            <Col xs={12} md={2} lg={3} className="d-flex w-100">
              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 w-100">
                <div>
                  <Button
                    className="d-flex align-items-center btn-primary gap-3"
                    style={{ height: "2.2rem", minWidth: "max-content" }}
                    size="sm"
                    onClick={() => {
                      setSearchString("");
                      setPaymentMethod("");
                      setLimit(15);
                      setPage(1);
                      setStatus("");
                      onResetDateFiltered()

                    }}
                  >
                    <span>Reset Filters</span>
                    <FontAwesomeIcon icon={faRedoAlt} />
                  </Button>
                </div>
                <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center ms-md-auto">

                  <div>
                    {customColSetting}
                  </div>

                  <Button
                    className="d-flex align-items-center btn-primary gap-2"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    disabled={transactions?.count === 0}
                    onClick={() => handleDownload('csv', 'Withdrawal Request')}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                    <span>Download CSV</span>
                  </Button>

                  {/* Column Dropdown */}

                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </div>
      <TransactionsList
        page={page}
        setLimit={setLimit}
        limit={limit}
        setPage={setPage}
        totalPages={totalPages}
        transactions={transactions}
        isTenant={false}
        transactionType="withdrawal"
        loading={loading}
        agentId={agentId}
        openStatusModal={openStatusModal}
        closeStatusModal={closeStatusModal}
        handleStatusChange={handleStatusChange}
        handleAgentIdChange={handleAgentIdChange}
        updateTransactionStatus={updateTransactionStatus}
        updatingStatus={updatingStatus}
        newStatus={newStatus}
        showStatusModal={showStatusModal}
        selectedTransaction={selectedTransaction}
        driversList={driversList}
        visibleColumns={visibleColumns}
        tableMaxHeight={tableMaxHeight}
        showCryptoStatusModal={showCryptoStatusModal}
        setShowCryptoStatusModal={setShowCryptoStatusModal}
        updateCryptoTransactionStatus={updateCryptoTransactionStatus}

        openCryptoStatusModal={openCryptoStatusModal}
        loadingCrypto={loadingCrypto}
        setSelectedTransaction={setSelectedTransaction}
        selectedCrypto={selectedCrypto}
        isWithdraw={true}
        withdrawlCryptoCheck={withdrawlCryptoCheck} depositCryptoCheck={depositCryptoCheck}
      />
    </div>
  );
}